import { StreetContent } from "../../components/boundary"

export default function Street () {
  return (
    <>
      <StreetContent/>
    </>
  )
}
